import React from 'react';

const MediaLibrary: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Media Library</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage your images and files
        </p>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 text-center">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-2xl">📁</span>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Media Library Coming Soon
        </h3>
        <p className="text-gray-500">
          Upload and manage images, documents, and other media files.
        </p>
      </div>
    </div>
  );
};

export default MediaLibrary;
